import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

/**
 * Stale bundle auto-recovery
 *
 * Deploy ut\u00e1n el\u0151fordulhat, hogy a b\u00f6ng\u00e9sz\u0151 cache-elt index.html r\u00e9gi
 * hash-\u0171 JS chunk-okra mutat, amelyek m\u00e1r nem l\u00e9teznek a szerveren.
 * Ilyenkor a lazy import elhasal (ChunkLoadError / "Loading chunk * failed"),
 * \u00e9s pl. a login click ut\u00e1n l\u00e1tsz\u00f3lag nem t\u00f6rt\u00e9nik semmi \u2014 csak inkognit\u00f3
 * b\u00f6ng\u00e9sz\u0151b\u0151l (ahol nincs cache) m\u0171k\u00f6dik a rendszer.
 *
 * Megold\u00e1s: figyelj\u00fck a chunk-load hib\u00e1kat, \u00e9s automatikusan teljes
 * reload-ot v\u00e9gz\u00fcnk cache-bypass query parameter-rel. Per session csak
 * egyszer reloadolunk, hogy ne ker\u00fclj\u00fcnk v\u00e9gtelen ciklusba (ha a hiba
 * t\u00e9nylegesen nem cache, hanem val\u00f3s build hiba).
 */
const RELOAD_FLAG_KEY = '__chunk_reload_attempted';

function isChunkLoadError(message: unknown): boolean {
  if (typeof message !== 'string') return false;
  return (
    message.includes('ChunkLoadError') ||
    message.includes('Loading chunk') ||
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('error loading dynamically imported module') ||
    message.includes('Importing a module script failed')
  );
}

function reloadOnce(): void {
  try {
    if (sessionStorage.getItem(RELOAD_FLAG_KEY) === '1') {
      // m\u00e1r pr\u00f3b\u00e1ltunk \u2014 ne reloadoljunk megint, h\u00e1tha val\u00f3di hiba
      return;
    }
    sessionStorage.setItem(RELOAD_FLAG_KEY, '1');
  } catch {
    // sessionStorage nem el\u00e9rhet\u0151 \u2014 m\u00e9gis pr\u00f3b\u00e1lkozzunk
  }
  // Cache-bypass: a query string megv\u00e1ltoztatja a request URL-t,
  // \u00edgy a b\u00f6ng\u00e9sz\u0151 friss index.html-t k\u00e9r a szervert\u0151l.
  const url = new URL(window.location.href);
  url.searchParams.set('_v', Date.now().toString());
  window.location.replace(url.toString());
}

window.addEventListener('error', (event: ErrorEvent) => {
  if (isChunkLoadError(event.message) || isChunkLoadError(event.error?.message)) {
    reloadOnce();
  }
});

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  const reason = event.reason;
  const message = typeof reason === 'string' ? reason : reason?.message;
  if (isChunkLoadError(message)) {
    reloadOnce();
  }
});

// Sikeres bootstrap ut\u00e1n t\u00f6r\u00f6lj\u00fck a reload-flaget, hogy egy k\u00e9s\u0151bbi
// (m\u00e1sik) deploy ut\u00e1n is m\u0171k\u00f6dj\u00f6n az auto-recovery.
bootstrapApplication(App, appConfig)
  .then(() => {
    try {
      sessionStorage.removeItem(RELOAD_FLAG_KEY);
    } catch {
      // ignore
    }
  })
  .catch((err) => {
    if (isChunkLoadError(err?.message)) {
      reloadOnce();
      return;
    }
    console.error(err);
  });
